/* eslint-disable no-nested-ternary */
/* eslint-disable array-callback-return */
import Loader from "@fdn/loader";
import { useLoadSelfQuery } from "@fdn/rtk_profile_store";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import Env from "Consts/env";
import vars from "Consts/vars";
import { mappingParentAndSubparentCategory, mappingTopNavigationDesktop } from "Helpers/categoryMap";
import ClientCookies from "js-cookie";
import dynamic from "next/dynamic";
import React, {
	useCallback, useEffect, useMemo, useState,
} from "react";
import { isFirefox, isMobile } from "react-device-detect";
import {
	productApiSlice,
	useGetListUserWishlistQuery,
	useGetQuickReviewProductQuery,
	useLazyGetListFlashSaleQuery,
} from "@/Store/rtk-query/feature/service/productApiSlice";
import { homeApiSlice, useLazyGetHomeDetailQuery } from "@/Store/rtk-query/feature/service/homeApiSlice";
import { useGetCategoryListQuery } from "@/Store/rtk-query/feature/service/categoryApiSlice";
import { brandsApiSlice } from "@/Store/rtk-query/feature/service/brandApiSlice";
import { useGetDataBannerQuery } from "@/Store/rtk-query/feature/service/bannerApiSlice";
import { wrapper } from "@/Store/index";

const CategoryPopup = dynamic(() => import("Components/category-popup"), { ssr: false });
const AddToCartPopup = dynamic(() => import("Components/add-to-cart-popup"), { ssr: false });
const Drawer = dynamic(() => import("Components/drawer"), { ssr: true });
const ChildListProducts = dynamic(() => import("Containers/child-list-products"), { ssr: true });
const LoadingSection = dynamic(() => import("Containers/loading-section"), { ssr: true });
const Navigation = dynamic(() => import("Components/navigation"), { ssr: false });
const SectionList = dynamic(() => import("Containers/section-list"), { ssr: false });
const Layout = dynamic(() => import("Containers/layout"), { ssr: true });
const Section = dynamic(() => import("Containers/section"),
	{
		ssr: false,
		loading: () => <LoadingSection type="default" isMobile={false} />,
	});
const BannerPopUp = dynamic(() => import("Components/banner-popup"), { ssr: true });
const BannerSliderHome = dynamic(() => import("Containers/banner-slider-home"),
	{
		ssr: false,
		loading: () => <LoadingSection type="banner" isMobile={false} />,
	});
const ChildDetailQuickReview = dynamic(() => import("Containers/child-detail-quick-review"),
	{ ssr: false });
const ChildListBrands = dynamic(() => import("Containers/child-list-brands"), { ssr: false });
const ModalQuickReview = dynamic(() => import("Components/modal-quick-review"), { ssr: false });
const Popup = dynamic(() => import("Components/pdp-popup"), { ssr: false });

const Index = (props) => {

	const authorization = ClientCookies.get("token") || null;
	const usrname = ClientCookies.get("usrname") || null;
	const userId = ClientCookies.get("user_id") || null;
	const data = props;
	const customUrl = `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api/fds-profile/me`;

	// for get data self profile
	const {
		data: selfDataResponse, isFetching, isLoading: isLoadingGetSelf,
	} = useLoadSelfQuery((authorization && usrname) ? {
		api_env: process.env.NEXT_PUBLIC_NODE_ENV,
		customUrl,
		Authorization: authorization,
		env: Env.HEADERS,
		is_server: false,
	} : skipToken);

	const selfData = selfDataResponse?.data?.data;

	// For handling main banner and popup banner
	const { data: dataBannerTop, isLoading: loadingGetBannerTop } = useGetDataBannerQuery(
		{ placement: "desktop_home_bs" },
	);

	const { data: dataBannerPopup, isLoading: loadingGetBannerPopup } = useGetDataBannerQuery(
		{ placement: "FDS_home_desktop_popup" },
	);

	// For get list category desktop and mobile
	const {
		data: dataCategoryDesktop,
	} = useGetCategoryListQuery({ placement: 2 });

	const getStoreCategoryDesktop = useMemo(() => mappingTopNavigationDesktop(dataCategoryDesktop),
		[dataCategoryDesktop]);

	const {
		data: dataCategoryMobile,
	} = useGetCategoryListQuery({ placement: 3 });

	const getStoreCategory = useMemo(() => mappingParentAndSubparentCategory(dataCategoryMobile),
		[dataCategoryMobile]);

	const {
		data: getWishlist, isLoading: isLoadingWishListProduct,
	} = useGetListUserWishlistQuery(userId && authorization ? {
		params: {
			userid: userId,
			authorization,
		},
	} : skipToken);

	// For handling flashSale data
	const [triggerFlashSale, dataFlashSale] = useLazyGetListFlashSaleQuery();

	// handling detail home data
	const [triggerHomeDetail] = useLazyGetHomeDetailQuery();

	// Quick Review
	const [quickReviewItem, setQuickReviewItem] = useState("");
	const {
		data: quickReviewData,
		isLoading: loadingGetQuickReview,
		isFetching: fetchingGetQuickReview,
	} = useGetQuickReviewProductQuery(quickReviewItem ? { params: quickReviewItem } : skipToken);

	const [showCategory, setShowCategory] = useState(false);
	const [isShowModal, setShowModal] = useState(false);
	const [HomePageList, setHomePageList] = useState(data.storeListDataHomepage);
	const [HomePageListLoading, setHomePageListLoading] = useState(data.listSectionLoad);
	const [HomePageListErr, setHomePageListErr] = useState(data.listSectionErr);
	const [bannerPopup, setBannerPopup] = useState(null);
	const [addToCartLoading, setAddToCartLoading] = useState(false);
	const [addToCartPopupShow, setAddToCartPopupShow] = useState({
		show: false,
		addedProduct: {},
		productId: 0,
	});
	const [popupShow, setPopupShow] = useState({
		show: false,
		message: "",
		color: "#323942",
		redirect: false,
		closable: false,
	});

	const HandleClickNavigation = (val) => {

		if (val === "category") {

			setShowCategory(true);

		}

		if (val === "brand") {

			window.location.href = "/brands";

		}

		if (val === "home") {

			window.location.href = "/";

		}

		if (val === "user") {

			if (selfData.id) {

				window.location.href = `${process.env.NEXT_PUBLIC_SSO_DOMAIN}/user/${selfData.username}`;

			} else {

				window.location.href = process.env.NEXT_PUBLIC_SSO_DOMAIN;

			}

		}

	};

	const HandleQuickReview = async (params) => {

		setQuickReviewItem(params);
		setShowModal(true);

	};

	useEffect(() => {

		if (!loadingGetBannerPopup) {

			setBannerPopup(dataBannerPopup?.data?.length > 0 ? dataBannerPopup.data[0] : null);

		}

	}, [loadingGetBannerPopup]);

	const passStoreSelf = useCallback(() => {

		if (authorization && usrname) {

			return { data: selfData };

		}

		return { status: vars.FETCH_RESULT };

	}, [selfData]);

	const refetchListHomepage = async () => {

		await Promise.all(data.storeListDataHomepage?.map(async (item) => {

			const isFlashSaleSlide = item.endpoint?.toLowerCase().includes("flash_sale");
			const onSaleParam = item.endpoint?.split("?")[1];
			let dataTmp = { ...item };

			if (!item.data) {

				const items = {
					...item,
					endpoint: `/fds-product?${onSaleParam}`,
				};

				if (!isFlashSaleSlide) {

					const dataDetail = await triggerHomeDetail({
						params: {
							...items,
							isDirect: false,
						},
					});

					if (dataDetail.isError) {

						dataTmp = { ...dataTmp };
						setHomePageListErr((prev) => ({
							...prev,
							[item.tipe_data]: true,
						}));

					}

					if (dataDetail.isSuccess) {

						dataTmp = { ...dataTmp, ...dataDetail?.data };
						setHomePageListErr((prev) => ({
							...prev,
							[item.tipe_data]: false,
						}));

					}

					if (!dataDetail.isLoading) {

						if (item.tipe_data !== "flash_sale") {

							setHomePageListLoading((prev) => ({
								...prev,
								[item.tipe_data]: !!prev[item.tipe_data],
							}));

						}

					}

				} else {

					triggerFlashSale({ page: 1, limit: 10 });

				}

			}

			return dataTmp;

		})).then((res) => {

			setHomePageList(res);

		}).catch(() => {

			setHomePageList([]);

		});

	};

	useEffect(() => {

		refetchListHomepage();

	}, []);

	useEffect(() => {

		if (dataFlashSale.isSuccess) {

			setHomePageListErr((prev) => ({
				...prev,
				flash_sale: false,
			}));
			setHomePageListLoading((prev) => ({
				...prev,
				flash_sale: false,
			}));

		} else if (dataFlashSale.isLoading || dataFlashSale.isUninitialized) {

			setHomePageListErr((prev) => ({
				...prev,
				flash_sale: false,
			}));
			setHomePageListLoading((prev) => ({
				...prev,
				flash_sale: true,
			}));

		} else if (dataFlashSale.isError) {

			setHomePageListErr((prev) => ({
				...prev,
				flash_sale: true,
			}));
			setHomePageListLoading((prev) => ({
				...prev,
				flash_sale: false,
			}));

		}

	}, [dataFlashSale]);

	return (
		<>
			{
				bannerPopup && !loadingGetBannerPopup && (
					<BannerPopUp
						url={bannerPopup.url}
						name={bannerPopup.name}
						image={bannerPopup.image}
						description={bannerPopup.description}
						isMobile={false}
					/>
				)
			}
			<Layout
				home
				title="Femaledaily"
				typeNavbarSecondary="type-3"
				titleNavbar="Situs Jual Beli Skincare dan Kosmetik Terlengkap"
				ismobile={false}
				self={passStoreSelf()}
				isFetchComplete={!isLoadingGetSelf}
				categoryDesktop={getStoreCategoryDesktop}
				getQuoteIdErrMessage={null}
				metaTitle="Situs Jual Beli Skincare dan Kosmetik Terlengkap"
				isShowSecondaryNav={false}
			>
				{!loadingGetBannerTop && dataBannerTop?.data ? (
					<BannerSliderHome isMobile={false} data={dataBannerTop?.data} />
				) : (
					<LoadingSection isMobile={false} type="banner" />
				)}

				{
					data && HomePageList?.length > 0 && HomePageList?.map((item, idx) => {

						const title = item?.title;
						const tipeData = item?.tipe_data;
						const redirect = item?.has_more ? item?.web_view_all_url : null;
						// const isWishlistActive = getWishlist?.data?.length > 0;
						const dataProduct = (
							// isWishlistActive ||
							!(selfData?.id)) && title === "For You" ? null
							: tipeData === "product_list" ? (item.data && item.data?.products?.slice(0, 6))
								: tipeData === "brand_campaign" ? (item.data && item.data[0]?.products?.slice(0, 6)) || (item.data && item.data?.products?.slice(0, 6))
									: tipeData === "flash_sale" ? (dataFlashSale.data && dataFlashSale.data.products)
										: item?.data;
						const isFlashSaleClosed = tipeData === "flash_sale" && (dataFlashSale.data && dataFlashSale.data?.category && dataFlashSale.data?.category[0] && (dataFlashSale.data?.category[0]?.flashsale_status === "closed"));
						const isFlashSaleSection = ((tipeData === "flash_sale") || (dataProduct?.length || 0) > 0);
						const isLoadingSection = (tipeData === "flash_sale" ? (HomePageListLoading.flash_sale && (dataFlashSale.isLoading || dataFlashSale.isUninitialized)) : HomePageListLoading[tipeData]);

						return (
							isFlashSaleSection && (isFlashSaleClosed ? null
								: (
									<React.Fragment key={`${title}-${String(idx)}`}>
										<Section
											isLoadingSection={isLoadingSection}
											isErrorSection={HomePageListErr && HomePageListErr[tipeData]}
											handleRefetch={() => (tipeData === "flash_sale" ? triggerFlashSale({ page: 1, limit: 10 }) : refetchListHomepage())}
											title={title}
											isMobile={false}
											isMozilla={isFirefox}
											urlViewMore={redirect}
											color={item.color ?? "#DB264D"}
											background={tipeData === "flash_sale" ? "#F9FAFB" : item.background_color}
											type={
												tipeData === "flash_sale" ? "flash-sale"
													: tipeData === "brand_campaign" ? "brand-campaign"
														: isMobile && (tipeData === "collection" || tipeData === "flash_sale" || tipeData === "brand_campaign") ? "slider"
															: "default"
											}
											date={
												(tipeData === "flash_sale" && !HomePageListLoading[tipeData])
													? (dataFlashSale.data && dataFlashSale.data.category[0]
														&& dataFlashSale.data.category[0].dateline)
													: null
											}
											banner={
												(tipeData === "flash_sale" && !HomePageListLoading[tipeData])
													? (dataFlashSale.data && dataFlashSale.data.category[0]
														&& dataFlashSale.data.category[0].banner)
													: null
											}
											runText={tipeData !== "flash_sale" && item?.short_description?.toUpperCase()}
											description={tipeData !== "flash_sale" && item?.description}
											logoUrl={tipeData !== "flash_sale" && item?.image}
											flashSaleType={isLoadingSection ? "upcoming" : dataFlashSale.data?.category[0]?.flashsale_status}
										// flashSaleType="upcoming"
										>
											<SectionList
												isLoadingSection={isLoadingSection}
												type={tipeData}
												isMobile={false}
												data={dataProduct}
												handleQuickReview={HandleQuickReview}
												isFlashSale={tipeData === "flash_sale"}
											/>

										</Section>
									</React.Fragment>
								))
						);

					})
				}

				{/* Section Product wishlist is avaliable or not ? */}
				{
					((isLoadingGetSelf) || (isFetching) || (isLoadingWishListProduct))
						&& authorization
						? (
							<LoadingSection isMobile={false} />
						) : (((selfData?.id)
							&& (getWishlist?.data?.length > 0))
							&& (
								<Section isMobile={false} isMozilla={isFirefox} title="Your Wishlist" urlViewMore={`${process.env.NEXT_PUBLIC_SSO_DOMAIN}/user/wishlist`}>
									<ChildListProducts
										isMobile={false}
										data={getWishlist && getWishlist?.data}
										handleQuickReview={HandleQuickReview}
									/>
								</Section>
							))
				}

				{data?.storeBrands?.data?.length > 0 && (
					<Section
						isMobile={false}
						isMozilla={isFirefox}
						title="Featured Brands"
						urlViewMore="/brands"
						background="#F9FAFB"
					>
						<ChildListBrands
							isMobile={false}
							data={data && data.storeBrands && data.storeBrands.data}
						/>
					</Section>
				)}

				<Navigation
					isMobile={false}
					showCategory={showCategory}
					onClick={(value) => HandleClickNavigation(value)}
					active="home"
				/>

				<CategoryPopup
					isMobile={false}
					show={showCategory}
					data={getStoreCategory}
					onHide={() => setShowCategory(false)}
					destinationUrl={`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/category`}
				/>

				<ModalQuickReview show={isShowModal} onClick={() => setShowModal(false)} closable>
					<ChildDetailQuickReview
						data={{
							...quickReviewData?.data?.product,
						}}
						isLoading={loadingGetQuickReview || fetchingGetQuickReview}
						closeModal={() => setShowModal(false)}
						setPopupShow={(val) => setPopupShow(val)}
						setAddToCartLoading={(val) => setAddToCartLoading(val)}
						setAddToCartPopupShow={(val) => setAddToCartPopupShow(val)}
					/>
				</ModalQuickReview>

				{addToCartLoading && (
					<>
						<div className="fdn-loader">
							<Loader />
						</div>
						<style>
							{`
								.fdn-loader {
									position:absolute;
								}
							`}
						</style>
					</>
				)}

				<Popup
					isMobile={data?.isMobile}
					color={popupShow?.color}
					show={popupShow?.show}
					onHide={() => {

						setPopupShow(false);

						if (popupShow?.redirect) {

							window.location.href = `${process.env.NEXT_PUBLIC_SSO_DOMAIN}/my/account`;

						}

					}}
					closable={popupShow?.closable}
					text={popupShow?.message}
					withOk={false}
				/>

				{/* Drawer for add to cart configurable products */}
				<Drawer
					isMobile={false}
					contentBackground="#FFF"
					title="Added to Cart!"
					headerIconSrc="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/fdn-studio-new/static/added-to-cart.png"
					onHide={() => setAddToCartPopupShow((prev) => ({
						show: false,
						addedProduct: prev.addedProduct,
						productId: prev.productId,
					}))}
					type="with-overlay"
					show={addToCartPopupShow?.show}
				>
					<AddToCartPopup
						isMobile={false}
						addedProduct={addToCartPopupShow?.addedProduct}
						productId={addToCartPopupShow?.productId}
					/>
				</Drawer>
			</Layout>
		</>
	);

};

export const getStaticProps = wrapper.getStaticProps(
	async ({ store }) => {

		const forYourQuery = {
			isDirect: true,
			page: "1",
			limit: "5",
			category: "for-you",
			placement: 2,
		};

		const brandDataQuery = {
			isDirect: true,
			all: "all",
			page: "",
			initial: "",
			sort: "",
			limit: 8,
			is_featured: "1",
		};

		await Promise.all([
			store.dispatch(
				homeApiSlice.endpoints.getSectionHome.initiate({
					params: { isDirect: true },
				}),
			),
			store.dispatch(
				productApiSlice.endpoints.getProductList.initiate({
					params: forYourQuery,
				}),
			),
			store.dispatch(
				brandsApiSlice.endpoints.getListBrands.initiate({
					params: brandDataQuery,
				}),
			),
		]);

		const state = store.getState();

		const getStoreHomepage = homeApiSlice.endpoints.getSectionHome.select({
			params: { isDirect: true },
		})(state).data;

		const getStoreProducts = productApiSlice.endpoints.getProductList.select({
			params: forYourQuery,
		})(state).data;

		let getStoreBrands = brandsApiSlice.endpoints.getListBrands.select({
			params: brandDataQuery,
		})(state).data;

		getStoreBrands = {
			...(Object.keys(getStoreBrands?.data ?? {}).length > 0 && {
				...getStoreBrands,
				data: [
					...getStoreBrands?.data?.slice(0, 8),
				],
			}),
		};

		let listDataHomepages = [];

		if (getStoreHomepage?.data?.length > 0) {

			// * split section "sale" because the section have dynamic data
			const dynamicSection = getStoreHomepage?.data.filter((item) => item.endpoint?.toLowerCase().includes("sale"));
			const staticSection = getStoreHomepage?.data.filter((item) => !item.endpoint?.toLowerCase().includes("sale"));

			// * get detail data for each section
			const sectionStaticHaveData = await Promise.all(
				staticSection.map(async (item) => {

					const data = { ...item };

					const detailData = await store.dispatch(homeApiSlice.endpoints.getHomeDetail.initiate(
						{ params: { ...item, isDirect: true } },
					));

					if (detailData.isError) {

						return { ...data, data: null, error: true };

					}

					return { ...data, data: detailData?.data?.data, error: false };

				}),
			);

			// * only set data null and false error for dynamic data
			const sectionDynamicData = dynamicSection.map((item) => (
				{ ...item, data: null, error: false }
			));

			// * merge section dynamic and static
			const AllSectionHome = [...sectionStaticHaveData, ...sectionDynamicData];
			listDataHomepages = AllSectionHome.sort((a, b) => a.position - b.position);

		}

		const listSectionLoad = Object.assign(...listDataHomepages.map((item) => (
			{ [item.tipe_data]: !item.data })));

		const listSectionErr = Object.assign(...listDataHomepages.map((item) => (
			{ [item.tipe_data]: item.error !== undefined ? item.error : null })));

		return {
			props: {
				storeProducts: getStoreProducts || null,
				storeBrands: getStoreBrands || null,
				storeListDataHomepage: listDataHomepages || null,
				listSectionLoad: listSectionLoad || null,
				listSectionErr: listSectionErr || null,
			}, // will be passed to the page component as props
			revalidate: 10,
		};

	},
);

export default Index;
